$(document).ready(function(){
    function getButtonVariantId($button) {
        const buttonVariantId = $button.data('variant-id');
        if (buttonVariantId) return buttonVariantId;

        const $productItem = $button.closest('.prod_item');
        const productItemVariantId = $productItem.attr('data-variant-id');
        if (productItemVariantId) return productItemVariantId;

        const variantJson = $productItem.attr('data-variant');
        if (!variantJson) return null;

        try {
            return JSON.parse(variantJson).id;
        } catch (error) {
            console.error('Invalid product variant data:', error);
            return null;
        }
    }

    function buildCartItem(variantId) {
        const $variantBox = $('.variant-box[data-variant-id="' + variantId + '"]');
        const preorderValue = $variantBox.attr('data-preorder');
        const formattedPreorderDate = window.extractAndFormatDate(preorderValue);
        let itemData = {
            id: variantId,
            quantity: 1
        };

        if (preorderValue && preorderValue.trim() !== '' && formattedPreorderDate) {
            itemData.properties = {
                'Pre-order': formattedPreorderDate
            };
        }

        return itemData;
    }

    function showAddToCartError(error) {
        const message = error?.message || 'Unable to add this item to cart.';

        if (typeof window.showWarning === 'function') {
            window.showWarning(message);
        } else {
            console.error(message);
        }
    }

    async function addBlastBountyItemToCart(ev) {
        ev.stopPropagation();
        ev.preventDefault();

        const $button = $(this);
        if ($button.hasClass('is-loading')) return;

        const variantId = getButtonVariantId($button);
        if (!variantId) {
            showAddToCartError(new Error('Missing variant id for Add To Cart button.'));
            return;
        }

        $button.addClass('is-loading').attr('aria-busy', 'true');

        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: [buildCartItem(variantId)]
                })
            });

            if (!response.ok) {
                let errorMessage = 'Unable to add this item to cart.';
                try {
                    const responseJson = await response.json();
                    errorMessage = responseJson.description || responseJson.message || errorMessage;
                } catch (error) {}
                throw new Error(errorMessage);
            }

            Shopify.getCart((cartTotal) => {
                document.body.classList.add("cart-sidebar-show");
                window.updateSidebarCart(cartTotal);
            });
        } catch (error) {
            showAddToCartError(error);
        } finally {
            $button.removeClass('is-loading').removeAttr('aria-busy');
        }
    }

    // ATC
    $('.prod-atc-btn').on('click', addBlastBountyItemToCart)
    // ATC
    $('.xmas-event-section .collections-prods .collections-lists .prod_item .atc_btn').on('click', addBlastBountyItemToCart);

    const $allProductsModule = $('.collections-prods.all-products-module');
    const productItemSelector = '.prod_item[data-product-type], .product[data-product-type], .product-item[data-product-type], [data-product-type][data-product-id][data-url]';
    const $imageModules = $allProductsModule.find('.images-lists .item-module-cont');
    const activeClass = 'all-prods-tab-item-active';

    function normalizeProductType(value) {
        return String(value || '').trim().toLowerCase();
    }

    function getCurrentProductItems() {
        return $allProductsModule.find(productItemSelector).filter(function() {
            return $(this).closest('.images-lists').length === 0;
        });
    }

    function getProductsByType(type) {
        const normalizedType = normalizeProductType(type);

        return getCurrentProductItems().filter(function() {
            return normalizeProductType($(this).attr('data-product-type')) === normalizedType;
        });
    }

    function showProductsByType(type, animate = false) {
        const $currentProductItems = getCurrentProductItems();
        const $targetProductItems = getProductsByType(type);

        $currentProductItems.stop(true, true).hide();

        if (animate) {
            $targetProductItems.fadeIn(400);
        } else {
            $targetProductItems.show();
        }

        if (typeof window.syncXmasEventProductVariantLabels === 'function') {
            window.syncXmasEventProductVariantLabels();
        }
    }

    getCurrentProductItems().hide();
    $imageModules.hide();
    
    showProductsByType('chairs');

    $('.chairs-main-iamge').show(); 

    $('.all-prods-tab-item').on('click', function() {
        const $this = $(this);
        
        $('.all-prods-tab-item').removeClass(activeClass);

        $this.addClass(activeClass);
        const targetType = $this.data('value');

        showProductsByType(targetType, true);

        $imageModules.hide();
        const $targetImg = $imageModules.filter(`[data-module-type="${targetType}"]`);
        
        if ($targetImg.length > 0) {
            $targetImg.fadeIn(400);
        } else {
            if (targetType === 'chairs') {
                $('.chairs-main-iamge').fadeIn(400);
            }
        }
    });

    const $rightDots = $('[data-blast-bounty-right-dots]');
    if ($rightDots.length) {
        const $section = $rightDots.closest('.xmas-event-section');
        const $dots = $rightDots.find('.blast-bounty-right-dots__item');
        const announcementSelector = 'announcement-bar-component';
        const headerSelector = '.header-navigation-wrapper';
        const bottomBuffer = 24;
        let ticking = false;
        let lastDotsMode = '';
        let lastAbsoluteTop = '';
        let lastFixedTop = '';
        let activeDotKey = '';

        const dotSections = [
            { key: 'Best-Sellers-of-the-Season', target: $('.collections-head-blast-bounty') },
            { key: 'Handpicked-Essentials', target: $('.Innovation-Picks') },
            { key: 'Find-Your-2026-Setup', target: $('.collections-prods.all-products-module') },
            { key: 'Bundle-Offers', target: $('#bundle-head') },
            { key: 'Influencer-Spotlight', target: $('.shopify-block.xmas-video-module') },
            { key: 'Verified-Reviews', target: $('.shopify-block.xmas-reviews-blocks') }
        ];

        function isMobile() {
            return window.matchMedia('(max-width: 767px)').matches;
        }

        function getHeaderOffset() {
            const announcementBar = document.querySelector(announcementSelector);
            const headerNavigation = document.querySelector(headerSelector);
            const announcementHeight = announcementBar ? announcementBar.getBoundingClientRect().height : 0;
            const headerHeight = headerNavigation ? headerNavigation.getBoundingClientRect().height : 0;

            return Math.max(Math.round(announcementHeight + headerHeight), 0);
        }

        function getFixedDotsTop(dotsHeight) {
            const viewportCenterTop = Math.round((window.innerHeight - dotsHeight) / 2);
            const minVisibleTop = getHeaderOffset() + bottomBuffer;
            const maxVisibleTop = Math.max(window.innerHeight - dotsHeight - bottomBuffer, minVisibleTop);

            return Math.min(Math.max(viewportCenterTop, minVisibleTop), maxVisibleTop);
        }

        function getInitialDotsTop() {
            if (!$section.length) return 0;

            const sectionEl = $section[0];
            const firstCard = $section.find('.collections-features-prod').first();
            const fallbackCard = $section.find('.collections-prods.all-products-module .container-prod').first();
            const $anchorCard = firstCard.length ? firstCard : fallbackCard;
            if (!$anchorCard.length) return 0;

            const sectionTop = sectionEl.getBoundingClientRect().top + window.scrollY;
            const cardTop = $anchorCard[0].getBoundingClientRect().top + window.scrollY;

            return Math.max(Math.round(cardTop - sectionTop), 0);
        }

        function setDotsLayout(mode, absoluteTop, fixedTop) {
            const absoluteTopValue = `${absoluteTop}px`;
            const fixedTopValue = `${fixedTop}px`;

            if (lastAbsoluteTop !== absoluteTopValue) {
                $section[0].style.setProperty('--blast-bounty-right-dots-top', absoluteTopValue);
                lastAbsoluteTop = absoluteTopValue;
            }

            if (lastFixedTop !== fixedTopValue) {
                $rightDots[0].style.setProperty('--blast-bounty-right-dots-fixed-top', fixedTopValue);
                lastFixedTop = fixedTopValue;
            }

            if (lastDotsMode !== mode) {
                $rightDots.toggleClass('is-fixed', mode === 'fixed');
                lastDotsMode = mode;
            }
        }

        function updateDotsPosition() {
            if (!$section.length || isMobile()) {
                $rightDots.removeClass('is-fixed');
                lastDotsMode = '';
                return;
            }

            const sectionEl = $section[0];
            const sectionRect = sectionEl.getBoundingClientRect();
            const sectionHeight = sectionRect.height;
            const dotsHeight = $rightDots.outerHeight() || 0;
            const initialTop = getInitialDotsTop();
            const fixedTop = getFixedDotsTop(dotsHeight);
            const maxTop = Math.max(Math.round(sectionHeight - dotsHeight - bottomBuffer), initialTop);
            const anchorViewportTop = sectionRect.top + initialTop;
            const sectionBottomLimit = sectionRect.bottom - bottomBuffer;

            if (anchorViewportTop > fixedTop) {
                setDotsLayout('absolute', initialTop, fixedTop);
                return;
            }

            if (sectionBottomLimit <= fixedTop + dotsHeight) {
                setDotsLayout('absolute', maxTop, fixedTop);
                return;
            }

            setDotsLayout('fixed', initialTop, fixedTop);
        }

        function setActiveDot(key) {
            if (!key && dotSections.length) {
                key = dotSections[0].key;
            }
            if (!key) return;
            if (activeDotKey === key) return;

            $dots.removeClass('is-active').attr('aria-current', 'false');
            const $active = $dots.filter(`[data-target-key="${key}"]`);
            $active.addClass('is-active').attr('aria-current', 'true');
            activeDotKey = key;
        }

        function syncDotsFromScroll() {
            const scrollTop = $(window).scrollTop();
            const scrollThreshold = scrollTop + getHeaderOffset() + 50;
            let currentKey = dotSections.length ? dotSections[0].key : '';

            dotSections.forEach((section) => {
                if (section.target.length) {
                    const targetTop = section.target.offset().top;
                    if (scrollThreshold >= targetTop) {
                        currentKey = section.key;
                    }
                }
            });

            setActiveDot(currentKey);
        }

        $dots.on('click', function() {
            const $this = $(this);
            const targetKey = $this.data('target-key');
            const matched = dotSections.find((section) => section.key === targetKey);

            if (!matched || !matched.target.length) return;

            const targetTop = matched.target.offset().top - getHeaderOffset();
            $('html, body').stop().animate({
                scrollTop: targetTop
            }, 800);
        });

        updateDotsPosition();
        syncDotsFromScroll();

        function requestDotsUpdate() {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(() => {
                updateDotsPosition();
                syncDotsFromScroll();
                ticking = false;
            });
        }

        $(window).on('scroll resize', function() {
            requestDotsUpdate();
        });

        if (window.ResizeObserver) {
            const observer = new ResizeObserver(() => {
                updateDotsPosition();
                syncDotsFromScroll();
            });

            if ($section.length) {
                observer.observe($section[0]);
            }

            const announcementBar = document.querySelector(announcementSelector);
            const headerNavigation = document.querySelector(headerSelector);

            if (announcementBar) {
                observer.observe(announcementBar);
            }

            if (headerNavigation) {
                observer.observe(headerNavigation);
            }
        }
    }
})
